import { render } from "./edit.vue?vue&type=template&id=5db016ff&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=5db016ff&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db016ff"],['__file',"vendor/wielink-application/shared/resources/vue/layouts/partials/sidebar/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5db016ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5db016ff', __exports__)) {
    console.log('reload')
    api.reload('5db016ff', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=5db016ff&scoped=true", () => {
    console.log('re-render')
    api.rerender('5db016ff', render)
  })

}


export default __exports__